import React from 'react';
import { useLocation } from 'react-router-dom';
import PreQualFunnelLayout from './PreQualFunnelLayout';
import { isProduction } from '../constants';
import styles from './LendAPIPrequal.module.scss';

interface LendAPIPrequalProps {
  productId: string;
}

const LendAPIPrequal: React.FC<LendAPIPrequalProps> = ({ productId }) => {
  const iframeSrc = `https://app.lendapi.com/application/product/${productId}/${
    isProduction() ? '?source=101458&purpose=Boat' : '?test_mode=1&custom=thisisatest'
  }`;

  console.log('[LendAPI - Parent] iframeSrc', iframeSrc);

  return (
    <PreQualFunnelLayout>
      <div className={styles.container}>
        <iframe
          src={iframeSrc}
          className={styles.lendApiFrame}
          title="LendAPI Product Studio"
          scrolling="no"
        />
      </div>
    </PreQualFunnelLayout>
  );
};

export default LendAPIPrequal;
